<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    :title="title"
    width="35%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <data-table
        :data="list"
        :pagination="false"
        :table-column="tableColumn"
        @changeBypagination="tableHandle"
      />
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import dataTable from '@/components/common/dataTable.vue';

export default {
  name: 'Orderdialog',
  components: { customeDialog, dataTable },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      title: '分类成绩列表',
      tableColumn: [
        {
          key: 'evaluationCategoryName',
          label: '分类名称',
          dataType: 'text',
        },
        {
          key: 'categoryTotalScore',
          label: '分类总成绩',
          width: '80px',
          dataType: 'text',
        },
        {
          key: 'categoryScore',
          label: '分类成绩',
          width: '80px',
          dataType: 'text',
        },
      ],
    };
  },
  watch: {
  },
  methods: {
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
    },
    confirm() {
      this.$emit('update:dialogVisible', false);
      this.$emit('confirm');
    },
  },
};
</script>
